/*!
 * domain.js 
 * 域名配置类,分成测试和上线两种情况*
 * name- LTY
 */

import { CLIENT_RENEG_LIMIT } from "tls";

const API_VERSION = '/api/v1';
//http://39.98.72.88
const LH = (process.env.NODE_ENV === 'production') ? 'http://api.lehuawang.dzhhb.com' + API_VERSION : 'http://api.lehuawang.dzhhb.com' + API_VERSION;
console.log(LH)

export default LH
